'use client';

import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import FollowingCreators from '@/app/[locale]/(worlds)/profile/[identifier]/components/FollowingCreators';
import EmptyFollowingCreatorsCard from '@/app/[locale]/(worlds)/profile/components/EmptyFollowingCreatorsCard';
import Loader from '@/components/Loader';
import ViverseSwitch from '@/components/ViverseSwitch';
import { useConfigsContext } from '@/context/ConfigsContext';
import { updateProfileMeByCmsAccountId } from '@/server/lib/profile';
export default function UserFollowingCreators() {
  const t = useTranslations();
  const router = useRouter();
  const {
    store,
    setStore
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  const cmsAccountId = store?.profile?.id;
  const showFollowingCreators = store?.profile?.showFollowingCreators ?? false;
  const [isSaving, setIsSaving] = useState(false);
  if (!htcToken) return null;
  const handleToggle = async (checked: boolean) => {
    if (!cmsAccountId || isSaving) return;
    setIsSaving(true);
    try {
      const res = await updateProfileMeByCmsAccountId(cmsAccountId, {
        show_following_creators: checked
      });
      if (res?.status === 200) {
        setStore(value => ({
          ...value,
          profile: {
            ...value.profile!,
            showFollowingCreators: checked
          }
        }));
        router.refresh();
      }
    } catch (error) {
      console.error('Failed to update following creators visibility:', error);
    } finally {
      setIsSaving(false);
    }
  };
  const titleAction = <div className="flex items-center gap-1.5">
      <span className="subheader-2 text-right font-semibold">
        {t('profile-page.following-creators.show-on-profile')}
      </span>
      {isSaving && <Loader size="xs" />}
      <ViverseSwitch checked={showFollowingCreators} onCheckedChange={handleToggle} disabled={isSaving} />
    </div>;
  return <FollowingCreators title={t('profile-page.following-creators.title-self')} titleAction={titleAction} emptyState={<EmptyFollowingCreatorsCard />} sectionClassName="md:px-8 lg:px-18" scrollContainerClassName="md:-mx-8 lg:-mx-18" contentClassName="pl-0 md:pl-8 lg:pl-18" />;
}